import { render } from "./Captcha.vue?vue&type=template&id=7a7fa206"
import script from "./Captcha.vue?vue&type=script&lang=js"
export * from "./Captcha.vue?vue&type=script&lang=js"

import "./Captcha.vue?vue&type=style&index=0&id=7a7fa206&lang=css"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__